export default __webpack_public_path__ + "static/media/unionpay.c0d0b84b.svg";